import { HttpClient } from '@angular/common/http';
import { Directive } from '@angular/core';
import {
    AbstractControl,
    AsyncValidator,
    AsyncValidatorFn,
    NG_ASYNC_VALIDATORS,
    ValidationErrors,
} from '@angular/forms';
import { Observable, of, startWith } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, first, map, switchMap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

export function takenLoginIdValidator(http: HttpClient, initialValue?: string): AsyncValidatorFn {
    return (ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
        return ctrl.valueChanges.pipe(
            startWith(ctrl.value),
            debounceTime(1000),
            distinctUntilChanged(),
            switchMap(() => isLoginIdTaken(http, ctrl.value)),
            map((isTaken) => (isTaken && initialValue !== ctrl.value ? { isTaken: true } : null)),
            first(),
            catchError(() => {
                return of(null);
            }),
        );
    };
}

export function isLoginIdTaken(http, loginId: string): Observable<boolean> {
    return http
        .get(`${environment.http.usersBaseUrl}users/check-user-login?loginId=${encodeURIComponent(loginId)}`)
        .pipe(map((response) => response['userAlreadyExists']));
}

@Directive({
    selector: '[appUniqueLoginId]',
    providers: [
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: TakenLoginIdDirective,
            multi: true,
        },
    ],
})
export class TakenLoginIdDirective implements AsyncValidator {
    constructor(private http: HttpClient) {}

    validate(ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
        return takenLoginIdValidator(this.http)(ctrl);
    }
}
